
/* 장바구니 안약 추천 - 담기 버튼 동작.
   어떤 상품을 보여줄지/숨길지는 전부 Liquid 가 서버에서 정합니다(이미 담긴 건 애초에 안 그려짐).
   이 파일이 하는 일은 "담기" 한 번 누르면 장바구니에 넣고 화면을 새로 그리는 것뿐입니다. */
(function () {
  if (window.__eeysUpsellBound) return;
  window.__eeysUpsellBound = true;

  function showError(btn, msg) {
    var root = btn.closest('[data-eeys-upsell]');
    var box = root && root.querySelector('[data-eeys-upsell-error]');
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
    setTimeout(function () { box.hidden = true; }, 4000);
  }

  /* 내가 들어있는 섹션만 다시 받아와서 갈아끼웁니다.
     카트페이지에서 쓰입니다. 방금 담은 상품이 목록에서 빠지고,
     남는 게 없으면 블록 자체가 사라집니다. */
  function refreshOwnSection(root) {
    var sid = root.getAttribute('data-section-id');
    if (!sid) return Promise.resolve();
    var holder = root.parentElement;
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-eeys-upsell]');
        if (fresh) {
          root.replaceWith(fresh);
        } else if (holder) {
          holder.innerHTML = '';
        }
      })
      .catch(function () {});
  }

  function afterAdd(root) {
    /* 카트페이지: 상품 목록/합계는 테마가 알아서 다시 그리고, 추천 블록은 내가 다시 받아옵니다. */
    var pageItems = document.querySelector('cart-items');
    if (pageItems && pageItems.tagName === 'CART-ITEMS' && typeof pageItems.onCartUpdate === 'function') {
      try { pageItems.onCartUpdate(); } catch (e) {}
      refreshOwnSection(root);
      return;
    }
    /* 카트 드로어: renderContents 에 빈 객체를 주면 테마가 스스로 섹션을 다시 받아옵니다. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && drawer.querySelector('.drawer__inner')) {
      try { drawer.renderContents({}); return; } catch (e) {}
    }
    window.location.reload();
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-eeys-upsell-add]') : null;
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled) return;

    /* 옵션이 여러 개인 상품은 카드 안 선택상자에서 고른 값을 쓴다. */
    var item = btn.closest('.eeys-upsell__item');
    var sel = item ? item.querySelector('[data-eeys-upsell-variant]') : null;
    var variantId = Number(btn.getAttribute('data-variant') || (sel && sel.value));
    if (!variantId) return;

    var root = btn.closest('[data-eeys-upsell]');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '담는 중';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (out) {
        if (!out.ok) throw new Error((out.data && out.data.description) || 'add_failed');
        afterAdd(root);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        showError(btn, '지금은 담을 수 없어요. 잠시 후 다시 시도해 주세요.');
      });
  });

  /* 옵션을 바꾸면 그 옵션 가격으로 표시를 갈아끼운다. 지금은 전 컬러가 같은 값이지만,
     나중에 옵션별로 가격이 갈려도 카드가 거짓말하지 않는다. */
  document.addEventListener('change', function (event) {
    var sel = event.target;
    if (!sel || !sel.matches || !sel.matches('[data-eeys-upsell-variant]')) return;
    var item = sel.closest('.eeys-upsell__item');
    var box = item && item.querySelector('[data-eeys-upsell-price]');
    var opt = sel.options[sel.selectedIndex];
    if (box && opt && opt.getAttribute('data-price')) box.textContent = opt.getAttribute('data-price');
  });
})();
